import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://azqoutrsnmzbwyqqnfcr.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6cW91dHJzbm16Ynd5cXFuZmNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzQ3NDY3NTksImV4cCI6MTk5MDMyMjc1OX0.454qcW0kwIBYgi1OvQRMPdj33ux_kZwKbASoVoy3CzI";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
